import React from 'react';
import { Platform } from 'react-native';
import * as DropdownMenu from '@/components/DropdownMenu/DropdownMenu';
import DropdownIcon from '@/components/DropdownMenu/DropdownIcon';
import PropTypes from 'prop-types';

function DropdownMenuCheckboxItem({onValueChange, isActive, label}) {
  return (
    <DropdownMenu.CheckboxItem 
      className="DropdownMenuCheckboxItem"
      onValueChange={onValueChange}
      value={isActive ? 'on' : 'off'}
      {...(Platform.OS === 'macos' ? { accessibilityLabel: label } : {})}
    >
      <DropdownMenu.ItemTitle className="DropdownMenuItemTitle">{label}</DropdownMenu.ItemTitle>
      <DropdownMenu.ItemIndicator className="DropdownMenuItemIndicator">
        <DropdownIcon isActive={isActive} />
      </DropdownMenu.ItemIndicator>
    </DropdownMenu.CheckboxItem>
  )
}

DropdownMenuCheckboxItem.propTypes = {
  onValueChange: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};

export default DropdownMenuCheckboxItem;
